import { useEffect, useState } from "react";
import { useSocket } from "../context/Socket";
import { useLazyGetTokensQuery } from "../service/api";
import { events } from "../utils/constant";

export default function useTokens() {
  const { io } = useSocket();
  const [isLoading, setIsLoading] = useState(false);
  const [tokens, setTokens] = useState<AssetToken[]>([]);
  const [filter, setFilter] = useState("");

  const [fetchTokens] = useLazyGetTokensQuery();

  const walletBalance = tokens.reduce((price, token) => {
    return (price += parseFloat(token.price));
  }, 0);

  const tokenWithoutNSTBL = tokens.filter((val) => val.symbol != "nStable");
  const availableWalletBalance = tokenWithoutNSTBL.reduce((price, token) => {
    return (price += parseFloat(token.price));
  }, 0);

  const getTokens = async (filter?: string) => {
    try {
      setIsLoading(true);
      const { data } = await fetchTokens(filter ? { filter } : {}).unwrap();
      setTokens(data);
    } catch (error: any) {
      console.log(error?.data);
    } finally {
      setIsLoading(false);
    }
  };

  const applyFilter = async (filter: string) => {
    const newFilter = filter === "all" ? "" : filter;
    setFilter(newFilter);
    await getTokens(newFilter);
  };

  const syncTokensHandler = async (data?: AssetToken[]) => {
    setTokens((items) => {
      if (!data || filter) return items;
      return data;
    });

    if (!data) {
      await getTokens(filter);
    }
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      io?.on(events.syncTokens, syncTokensHandler);
    }, 1000);
    return () => clearTimeout(timeout);
  }, [io]);

  useEffect(() => {
    getTokens();
  }, []);

  return {
    tokens,
    walletBalance,
    isLoading,
    applyFilter,
    filter,
    availableWalletBalance,
  };
}
